<template>
  <b-dropdown
    size="xl"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
    @show="onDropdownOpen"
  >
    <template v-slot:button-content>
      <font-awesome-icon
        :icon="['fas', 'plus-circle']"
        class="text-primary"
        style="cursor: pointer;"
      />
      <span class="sr-only"> {{ $t('treatments.searchDropdown') }} </span>
    </template>

    <input class="input-search-categories" v-model="categorySearch" />
    <button
      class="btn btn-outline-primary icon-eraser-category"
      @click="categorySearch = ''"
    >
      <i title="Limpar" class="fas fa-eraser"></i>
    </button>

    <template v-if="loadingCategories">
      <center>
        <b-spinner
          variant="success"
          type="grow"
          label="Spinning"
          class="bg-primary"
        ></b-spinner>
      </center>
    </template>

    <div v-if="options.length !== 0 && !loadingCategories">
      <b-dropdown-text style="margin-left: -35px;">
        <ul
          v-for="(option, i) in categoriesList"
          :key="i"
          style="font-size: 20px; list-style: none;"
        >
          <li>
            <i
              @click="showSubCategories($event, option._id, i)"
              :class="
                option.displaySubCategories
                  ? 'fas fa-caret-down'
                  : 'fas fa-caret-right'
              "
            />
            <input
              @click="handleCategoryClick($event, option._id)"
              style="zoom: 1.4;"
              type="checkbox"
              :value="option._id"
              :id="`${idItem}-${i}`"
              :name="`${idItem}-${i}`"
              :checked="
                myAnswer.categories.findIndex((el) => el._id === option._id) >=
                0
              "
            />
            {{ option.name }}

            <ul
              v-if="!loading && option.displaySubCategories"
              :id="`${option._id}`"
              style="display: block; list-style: none;"
            >
              <li
                v-for="(subcategory, index) in categoriesList[i].subCategories"
                :key="index"
              >
                <input
                  @click="
                    handleSubCategoryClick($event, option._id, subcategory._id)
                  "
                  type="checkbox"
                  style="zoom: 1.4;"
                  :value="subcategory._id"
                  :id="`${idItem}-${index}`"
                  :name="`${idItem}-${index}`"
                  :checked="
                    myAnswer.subCategories.findIndex(
                      (el) => el._id === subcategory._id,
                    ) >= 0
                  "
                />
                {{ subcategory.name }}
              </li>
            </ul>
          </li>
        </ul>
      </b-dropdown-text>

      <b-dropdown-text>
        <p>
          {{ $t('treatments.registerCategory') }}
          <router-link
            :to="{
              name: 'Configurações',
              params: { settings: 'add-category' },
            }"
            class="text-primary"
          >
            {{ $t('treatments.here') }}
          </router-link>
        </p>
      </b-dropdown-text>
    </div>

    <div v-else>
      <b-dropdown-text>
        <span>
          {{ $t('treatments.registerCategory') }}
          <router-link :to="`/settings`" class="preview">
            {{ $t('treatments.here') }}
          </router-link>
        </span>
      </b-dropdown-text>
    </div>
  </b-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../../services/api';

export default {
  props: {
    idItem: { type: String },
    categories: { type: Array },
    categoryGroupId: { type: String },
    myAnswer: { type: Object },
  },

  data: () => ({
    userAuth: null,
    categorySearch: '',
    actionCategories: [],
    options: [],
    loading: false,
    loadingCategories: false,
  }),

  computed: {
    ...mapState('treatments', ['answer', 'oneAnswer']),

    categoriesList() {
      return this.options.filter((option) => {
        return option.name
          .toLowerCase()
          .includes(this.categorySearch.toLowerCase());
      });
    },
  },

  methods: {
    onDropdownOpen(){
      this.getActionCategories();
    },

    async handleCategoryClick(event, categoryId) {
      const categoryIndex = this.options.findIndex(
        (el) => el._id === categoryId,
      );

      const category = this.options[categoryIndex];

      if (event.target.checked === true) {
        this.myAnswer.categories.push(category);

        await api.patch(
          `/answer-categories/${this.myAnswer._id}`,
          {
            operation: 'add',
            categoryId: event.target.value,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
      } else {
        const foundIndex = this.myAnswer.categories.findIndex(
          (el) => el._id === category._id,
        );

        if (foundIndex >= 0) {
          this.myAnswer.categories.splice(foundIndex, 1);
        }

        const response = await api.patch(
          `/answer-categories/${this.myAnswer._id}`,
          {
            operation: 'delete',
            categoryId: event.target.value,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        this.myAnswer.subCategories = response.data.subCategories;
      }
    },

    async handleSubCategoryClick(event, categoryId, subCategoryId) {
      let operation = null;

      const categoryIndex = this.options.findIndex(
        (el) => el._id === categoryId,
      );

      const category = this.options[categoryIndex];

      const subCategoryIndex = category.subCategories.findIndex(
        (el) => el._id === subCategoryId,
      );

      const subCategory = category.subCategories[subCategoryIndex];

      if (event.target.checked === true) {
        operation = 'add';
      } else {
        operation = 'delete';
      }

      if (event.target.checked === true) {
        const index = this.myAnswer.categories.findIndex(
          (el) => el._id === category._id,
        );

        if (index < 0) {
          this.myAnswer.categories.push(category);
        }

        this.myAnswer.subCategories.push(subCategory);
      } else {
        const index = this.myAnswer.subCategories.findIndex(
          (el) => el._id === subCategory._id,
        );

        if (index >= 0) {
          this.myAnswer.subCategories.splice(index, 1);
        }
      }

      await api.patch(
        `/category-subcategory/${this.myAnswer._id}`,
        {
          subCategoryId: subCategory._id,
          categoryId: category._id,
          operation,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async showSubCategories(event, categoryId, categoriesListIndex) {
      this.categoriesList[categoriesListIndex].displaySubCategories = !this
        .categoriesList[categoriesListIndex].displaySubCategories;

      if (this.categoriesList[categoriesListIndex].displaySubCategories) {
        event.target.classList.remove('fa-caret-right');
        event.target.classList.add('fa-caret-down');
      } else {
        event.target.classList.remove('fa-caret-down');
        event.target.classList.add('fa-caret-right');
      }

      this.loading = true;

      const response = await api.get(`/subcategories/${categoryId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.categoriesList[categoriesListIndex].subCategories = response.data;

      this.loading = false;
    },

    async getActionCategories() {
      this.loadingCategories = true;
      if (this.categoryGroupId) {
        try {
          const response = await api.get('/categories-dropdown', {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              categoryGroup: this.categoryGroupId,
            },
          });

          this.actionCategories = response.data;
          this.options = this.actionCategories;

          this.options.forEach((element) => {
            element.displaySubCategories = false;
            element.subCategories = [];
            element.loading = false;
          });
        } catch (error) {
          window.console.log(error);
        }
      }
      this.loadingCategories = false;
    },
  },

  mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu li {
  min-width: 250px !important;
  margin-bottom: 10px;
}

.icon-eraser-category {
  margin-left: -5px;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 5px;
}

.input-search-categories {
  width: 70%;
  margin-top: 10px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-left: 20px;
}

ul div {
  max-height: 250px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/dropdown-categories/index.vue